/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Donate_Plan_PlantInputs */

const en_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a special Earth Day plant`)
};

const ar_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على نبتة خاصة بيوم الأرض`)
};

const de_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holen Sie sich eine spezielle Pflanze zum Tag der Erde`)
};

const es_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigue una planta especial por el Día de la Tierra`)
};

const fr_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recevez une plante exclusive à l'occasion de la Journée de la Terre`)
};

const it_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni una pianta speciale per la Giornata della Terra`)
};

const ja_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アースデイ限定植物を入手`)
};

const ko_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지구의 날 기념 식물을 획득하세요`)
};

const pt_br_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha uma planta especial do Dia da Terra`)
};

const ru_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите специальное растение ко Дню Земли`)
};

const th_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับต้นไม้วันคุ้มครองโลกสุดพิเศษ`)
};

const tr_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel bir Dünya Günü bitkisi al`)
};

const zh_cn_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获得地球日限定植物`)
};

const zh_tw_earth_day_2025_donate_plan_plant = /** @type {(inputs: Earth_Day_2025_Donate_Plan_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲得地球日限定植物`)
};

/**
* | output |
* | --- |
* | "Get a special Earth Day plant" |
*
* @param {Earth_Day_2025_Donate_Plan_PlantInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_plan_plant = /** @type {((inputs?: Earth_Day_2025_Donate_Plan_PlantInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_Plan_PlantInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "de") return de_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "es") return es_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "it") return it_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "th") return th_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_plan_plant(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_plan_plant(inputs)
	return zh_tw_earth_day_2025_donate_plan_plant(inputs)
});